// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"6233fc51","118":"414146b3","135":"dc51f3e2","146":"b1e7120e","452":"e0d192df","453":"3cb1ae6e","462":"7264de8f","569":"707183fc","635":"801ea602","784":"68501cbd","900":"fdf037d9","939":"ef486f84"}[chunkId] + ".chunk.js";
};